import React, { useEffect } from 'react'
import { GridItem } from '@zuto/core/src/grid'
import Box from '@zuto/core/src/box'
import { useRouter } from 'next/router'
import { ArrowRight } from '@zuto/icons'
import ZutoAnalyticsHelper from '@zuto-internal/zuto-analytics-helper'
import $console from '@zuto/utilities/src/$console'
import { questionFontStyle, fireReactGAEvent } from '../Questions/utils'
import CenteredButton from '../../style/CenteredCTA'
import withFade from '../HOC/withFade'
import { useAppFormEventsService } from '../../hooks/useAppFormEventsService'
import { AmplitudeEvents, trackAmplitudeEvent } from '../../utils/amplitude-utils'
import { toSnakeCase } from '../../utils/string-utils'

const zutoAnalyticsHelper = new ZutoAnalyticsHelper()

type ResumeProps = {
  questionKey: string
}

const ResumeForm = ({ questionKey }: ResumeProps) => {
  const eventsService = useAppFormEventsService()
  const router = useRouter()
  const url = new URL(window.location.href)

  const backToForm = async () => {
    url.searchParams.delete('resume')
    window.history.pushState({}, '', url.href)
    delete router.query.resume
    router.push(url.href)
  }

  const resumeApp = () => {
    fireReactGAEvent({
      category: 'Application Form',
      action: 'CTA Clicked',
      label: `Safety Net - came from ${questionKey}`,
      nonInteraction: false
    })
    try {
      zutoAnalyticsHelper.sendCustomEvent({
        eventCategory: 'Application Form',
        eventType: 'Safety Net',
        eventAction: `CTA Clicked - came from ${questionKey}`
      })
    } catch (e) {
      $console.error('zutoAnalyticsHelper.sendCustomEvent error', e)
    }
    backToForm()
  }

  useEffect(() => {
    const label = `Safety Net - came from ${questionKey}`
    fireReactGAEvent({
      category: 'Application Form',
      action: 'Question Visible',
      label,
      nonInteraction: false
    })
    eventsService?.sendEvent('AppFormQuestionVisible', { QuestionLabel: label })
    trackAmplitudeEvent(AmplitudeEvents.ApplicationQuestionViewed, { question_label: toSnakeCase(label) })
  }, [])

  const continueButton = (
    <CenteredButton
      endSvgIcon={ArrowRight}
      onClick={resumeApp}
      data-testid="resume-button-centered"
    >
      Pick up where you left off
    </CenteredButton>
  )

  return (
    <>
      <GridItem
        gridColumn={['auto / span 12', '3 / span 8']}
        mt={4}
      >
        <Box
          textStyle={questionFontStyle}
          mt={3}
          mb={2}
        >
          Lose your quote
        </Box>
        <Box
          textStyle="body.smallPrint.regular"
          mb={4}
        >
          By leaving this page you will lose all progress on the current application.
        </Box>
      </GridItem>
      <>
        <GridItem
          display="flex"
          alignItems="center"
          gridColumn={['1 / span 12', '7 / span 4']}
          gridRow={['auto', '5 / auto']}
          mb={4}
        >
          {continueButton}
        </GridItem>
      </>
    </>
  )
}

export default withFade(ResumeForm)
